/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import 'fontsource-roboto';
import '../app.css';
import {
  Box,
  createStyles,
  Divider,
  Grid,
  makeStyles,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios, { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import useSWR from 'swr';
import type { ICompany, IStore } from './MassReceiveInterfaces';
import { ICompanyInformationProps } from './MassReceiveInterfaces';

const useStyles = makeStyles(() => createStyles({
  title: {
    fontWeight: 700,
    fontSize: 18,
  },
}));

const CompanyInformation: React.FC<{
  stores:IStore[] | null,
  company:ICompany | null,
  store:IStore | null,
  setStore: (store: IStore)=>(void),
  handleSelectedCompanyChange: (comapny:ICompany) => (void),
  trackingNumber: string | undefined,
  setTrackingNumber:(trackingNumberInput:string)=>void,
  storeRepairNumber: string | undefined,
  setStoreRepairNumber: (storeRepairNumberInput:string)=>void,
  elemDisabled: boolean,
}> = ({
  stores,
  company,
  store,
  setStore,
  handleSelectedCompanyChange,
  trackingNumber,
  setTrackingNumber,
  storeRepairNumber,
  setStoreRepairNumber,
  elemDisabled = false,
}) => {
  const classes = useStyles();
  const fetcher = (url: string) => axios.get<ICompany[]>(url)
    .then((response) => response.data);

  const { data: companies } = useSWR<ICompany[]>(
    ['/massreceive/getcompanies'],
    (url) => fetcher(url),
  );

  return (
    <Box>
      <Paper>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box pl={2}>
              <Typography className={classes.title}>{'Company Information'}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={6}>
            <Box pl={2}>
              <TextField
                required
                label="Tracking Number"
                id="tracking-number-input"
                variant="outlined"
                fullWidth
                value={trackingNumber}
                onChange={(e) => { setTrackingNumber(e.target.value); }}
                disabled={elemDisabled}
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box pr={2}>
              <TextField
                required
                label="Store Repair #"
                id="store-repair-number-input"
                variant="outlined"
                fullWidth
                value={storeRepairNumber}
                onChange={(e) => { setStoreRepairNumber(e.target.value); }}
                disabled={elemDisabled}
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box pl={2} pb={2}>
              <Autocomplete
                value={company}
                onChange={(event: unknown, selectedCompany: ICompany | null) => {
                  if (selectedCompany) { handleSelectedCompanyChange(selectedCompany); }
                }}
                autoHighlight
                autoSelect
                options={companies ?? []}
                getOptionLabel={(option) => option.companyName.toString()}
                // prop spreading is directly from MUI tsx example
                // eslint-disable-next-line react/jsx-props-no-spreading
                renderInput={(params) => <TextField required {...params} id="company-input" label="Company" variant="outlined" />}
                disabled={elemDisabled}
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box pr={2} pb={2}>
              <Autocomplete
                value={store}
                onChange={(event: unknown, selectedStore: IStore | null) => {
                  if (selectedStore) { setStore(selectedStore); }
                }}
                autoHighlight
                autoSelect
                options={stores || []}
                getOptionLabel={(option) => option.storeName}
                // prop spreading is directly from MUI tsx example
                // eslint-disable-next-line react/jsx-props-no-spreading
                renderInput={(params) => <TextField required {...params} id="store-input" label="Store" variant="outlined" />}
                disabled={elemDisabled}
              />
            </Box>
          </Grid>

        </Grid>
      </Paper>
    </Box>
  );
};

export default CompanyInformation;
